import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {ISelectedExpertPage} from "../reducers/selectedExpertPageSlice";

const useSelectedExpertPageSelectors = () => {
  const selectedExpert = useSelector<RootSliceType, ISelectedExpertPage["selectedExpert"]>(
    (state) => state.selectedExpertPageSlice.selectedExpert
  );
  return {
    selectedExpert,
  };
};

export default useSelectedExpertPageSelectors;
